import React, { memo, useMemo } from 'react';
import { Paper, Grid, Typography } from '@mui/material';
import { useMessage } from 'modules/intl';
import { LabelType, MyAnalyticsDimensionType } from 'graphql/types';
import { useGetMyAnalyticsData } from 'modules/Insights/Notes/hooks/useGetMyAnalyticsData';
import PieChart from './PieChart';
import LabelChartSkeleton from './LabelChartSkeleton';
import { LabelNoData } from './LabelNoData';
import { transformLabelData } from './utils';
import { useLabelStyles } from './hooks/useLabelStyles';

export const TaskChart: React.FC = () => {
  const classes = useLabelStyles();
  const name = useMessage('insights.timeSheetLabels.tasks');
  const { data, loading = true, isEmpty } = useGetMyAnalyticsData(
    MyAnalyticsDimensionType.MetricsByTask
  );
  const dataset = useMemo(() => {
    if (isEmpty) {
      return [];
    } else {
      return transformLabelData(data?.myAnalytics?.items, LabelType.Task);
    }
  }, [data?.myAnalytics?.items, isEmpty]);

  return (
    <Paper
      elevation={3}
      data-testid={'source-by-task-chart-container'}
      className={classes.container}
    >
      <Grid container direction="column" spacing={1}>
        <Grid item>
          <Typography
            className={classes.typography}
            variant="h6"
            data-testid="task-chart-title"
          >
            {name}
          </Typography>
        </Grid>
        <Grid item>
          {loading ? (
            <LabelChartSkeleton />
          ) : isEmpty ? (
            <LabelNoData />
          ) : (
            <PieChart data={dataset} labelType="TASK" />
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};
export default memo(TaskChart);
